/* eslint-disable solid/no-innerhtml */
import type { CompanyContactSchema } from '@/web-components/BapFormApp/BapFormSchema'
import { Show } from 'solid-js'
import { z } from 'zod'

type CompanyContactProps = {
  info: z.infer<typeof CompanyContactSchema>
}

export function CompanyContact(props: CompanyContactProps) {
  return (
    <div>
      <Show when={props.info} keyed>
        {(c) => (
          <address class="not-italic">
            <Show when={c.office_name}>
              <div class="text-lg font-bold">{c.office_name}</div>
            </Show>
            <Show when={c.contact_name}>
              <div class="text-lg font-bold">
                {c.contact_name}

                <Show when={c.contact_title}>
                  <span class="text-lg">, {c.contact_title}</span>
                </Show>
              </div>
            </Show>

            <Show when={c.address_1}>
              <div>{c.address_1}</div>
            </Show>
            <Show when={c.address_2}>
              <div>{c.address_2}</div>
            </Show>
            <Show when={c.state}>
              <div>
                {c.city}, {c.state} {c.zip_code}
              </div>
            </Show>

            <Show when={c.phone}>
              <div>
                <span class="font-bold">Ph:</span> {c.phone}
              </div>
            </Show>
            <Show when={c.fax}>
              <div>
                <span class="font-bold">Fax:</span> {c.fax}
              </div>
            </Show>

            <Show when={c.email}>
              <div>
                <span class="font-bold">Email:</span> <a href={`mailto:${c.email}`}>{c.email}</a>
              </div>
            </Show>
          </address>
        )}
      </Show>
    </div>
  )
}
